// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidemenu_root__kgHY4","select":"Sidemenu_select__juixD","closeModule":"Sidemenu_closeModule__5EHGn","cardLine":"Sidemenu_cardLine__YjShE"};